import moment from 'moment/moment'
import store from '@/stores/'
import UNIQUE from '@/common/unique'

const langValue = function (val) {
  const obj = Object.assign({}, store.state.setting.lang.langValue)
  Object.keys(obj).forEach(function (x) {
    obj[x] = val
  })
  return obj
}
export default {
  id: 'signaturepad',
  name: 'signaturepad',
  type: 'action',
  moduleName: 'editor_module_signaturepad',
  dataSet: {
    mods: 'signaturepad',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'signaturepad',
        value: langValue('Signature')
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'background',
        'border'
      ]
    },
    action: {
      name: 'signaturepad',
      isRequired: true,
      label: langValue('Signature'),
      labelValue: 'Signature',
      labelFontSize: 'default',
      valueFontSize: 'default'
    },
    detail: null
  }
}
